import { Handle, Position, type Node, type NodeProps } from '@xyflow/react';
import { Play, SlidersHorizontal } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useWorkflowNodeContext } from '../WorkflowNodeContext';
import type { WorkflowNodeData } from '../types';

type ActionNodeProps = NodeProps<Node<WorkflowNodeData, 'action'>>;

export function ActionNode({ id, data, selected }: ActionNodeProps) {
  const ctx = useWorkflowNodeContext();

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        className="!w-2.5 !h-2.5 !border-2 !bg-background !border-emerald-500"
      />
      <div
        className={cn(
          'min-w-[200px] rounded-lg border-2 bg-card px-3 py-2.5 shadow-sm transition-shadow',
          'border-emerald-500/60 bg-emerald-500/5',
          selected && 'ring-2 ring-emerald-500 ring-offset-2 shadow-md'
        )}
      >
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-emerald-500/20 text-emerald-600 dark:text-emerald-400">
            <Play className="h-4 w-4" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-foreground">Action</p>
            <p className="truncate text-xs text-muted-foreground">{data.label}</p>
          </div>
          {ctx && (
            <button
              type="button"
              className="nodrag nopan flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground"
              onClick={() => ctx.openProperties(id)}
              aria-label="Open step properties"
            >
              <SlidersHorizontal className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
        {data.description && (
          <p className="mt-1.5 line-clamp-2 text-xs text-muted-foreground">{data.description}</p>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-2.5 !h-2.5 !border-2 !bg-background !border-emerald-500"
      />
    </>
  );
}
